import React from 'react';
import PropTypes from 'prop-types';
import { CompactMenu } from '../../../NewHeader/compact-menu';
import { accountMenuData, compactMenuData } from '../../../NewHeader/compact-header-data';

const MobileMenuNew = (props) => {
  const {
    onNavItemSelected,
    open,
    user,
  } = props;

  const closeMenu = () => onNavItemSelected();

  return (
    <div
      className={`mobile-menu ${open ? 'open-menu' : ''}`}
      onClick={() => {
        closeMenu();
        // was the EU opt in open? if it was, re-open it
        const {
          EUBannerWasOpen,
          showEUBanner,
        } = props;
        if (EUBannerWasOpen) {
          // was open, so show it again
          showEUBanner();
        }
      }}
      onKeyPress={() => {}}
    >
      <CompactMenu
        menuData={compactMenuData}
        accountMenuData={accountMenuData}
        user={user}
      />
    </div>
  );
};

MobileMenuNew.propTypes = {
  gotoHandler: PropTypes.func,
  EUBannerWasOpen: PropTypes.bool,
  logoutHandler: PropTypes.func,
  onNavItemSelected: PropTypes.func,
  open: PropTypes.bool,
  // reportSendInteraction: PropTypes.func,
  showEUBanner: PropTypes.func,
  user: PropTypes.object,
};

export default MobileMenuNew;



// WEBPACK FOOTER //
// ./modules/App/components/children/Header/children/MobileMenu/MobileMenuNew.js